/**
 * Requests which don't relate to one entity
 */
import { Http } from 'Core/utils/axios'

export const retrieveLanguages = (): Promise<Entity[]> => Http.get('/languages')

export const retrieveSupplierLocations = (): Promise<Entity[]> => Http.get('/supplier-locations')
